import axios from "axios";
import {authApi} from "./AuthApiClient";

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

export async function getArchivePhotos(page, size,category) {
    try {
        return await api.get("/v2/archive/photos", {params: {page, size, category}});
    } catch (error) {
        return [];
    }
}

export async function getArchiveV2(page, size,category, content) {
    try {
        return await api.get("/v2/archive", {params: {page, size, category, content}});
    } catch (error) {
        return [];
    }
}

// 1-я фаза двухфазной загрузки: заливаем файл, получаем {url, content_type}
export async function uploadArchiveFile(file, onUploadProgress) {
    const formData = new FormData();
    formData.append("content", file);
    return await authApi.post('/v1/archive/upload', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        timeout: 600000,
        onUploadProgress,
    });
}

// 2-я фаза: создаём запись архива по уже загруженному url (быстрый JSON-запрос)
export async function createArchiveByUrl(url, contentType, title, author, description, category, createdAt) {
    const resultDate = new Date(createdAt.getTime() + 3 * 60 * 60 * 1000);
    return await authApi.post('/v1/archive', {
        title: title,
        author: author,
        description: description,
        category: category.value,
        created_at: resultDate,
        url: url,
        content_type: contentType,
    });
}

export async function createContent(file, title, author, description, category, createdAt, onUploadProgress) {
    const resultDate = new Date(createdAt.getTime() + 3 * 60 * 60 * 1000);

    const formData = new FormData();
    formData.append("content", file);

    const json = JSON.stringify({
        title: title,
        author: author,
        description: description,
        category: category.value,
        created_at: resultDate
    });

    formData.append("json", new Blob([json], {type: "application/json"}));

    return await authApi.post('/v1/archive', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
    });
}

export async function deleteContent(id) {
    return await authApi.delete("/v1/archive",{
        data: {
            id: id
        }
    });
}

export async function updateArchiveContent(id, title, author, description, createdAt) {
    const resultDate = new Date(createdAt.getTime() + 3 * 60 * 60 * 1000);
    return await authApi.patch(`/v1/archive`, {
        id: id,
        title: title,
        author: author,
        description: description,
        created_at: resultDate
    })
}
